module.exports = __webpack_public_path__ + "static/img/erplogo.36106fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/erplogo.png
// module id = gix3
// module chunks = 1